/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 16:31:39
* @Last Modified by:   Bolt
* @Last Modified time: 2017-01-11 22:37:04
*/

'use strict';

// require('../../../../../../../demo/chunyan-demo/S/pc-qiwa/sale-Crystal');
import './index.less';
import '@souche-f2e/chunyan-util/qiwa-common_m/lib/jquery.cookie.js';
import sellcar_main from './modules/sellcar_main/sellcar_main';

let $ = window.$;
var _store = {
    $html: $('.sellcar'),
    $wrapper: $('<div class="wrapper">')
};

var _control = {
    init: function () {
        this.bind();
    },
    bind: function () {
        var bgimg = _store.$html.attr('bgimg');
        if (bgimg && bgimg !== '[]') {
            _store.$html.css({
                'background-image': `url(${bgimg})`
            });
        } else {
            _store.$html.css({
                'background-image': 'url(//img.souche.com/20160422/png/2d11c94ba8126522b408b79596c54086.png)'
            });
            $('<div class="sellcar__h1">')
                .text(window._qiwa && window._qiwa.__basic_site_default_shop &&
                    `${window._qiwa.__basic_site_default_shop.nickname}专业评估`)
                .appendTo(_store.$wrapper);
        }
        _store.$wrapper
            .append(sellcar_main.$dom)
            .appendTo(_store.$html);
    }
};

_control.init();



// WEBPACK FOOTER //
// ./src/modules/sellcar/index.js